var React = require('react');

var Image = React.createClass({
    propTypes: {
        alt: React.PropTypes.string,
        desktopSrc: React.PropTypes.string.isRequired,
        height: React.PropTypes.number,
        mobileSrc: React.PropTypes.string.isRequired,
        title: React.PropTypes.string,
        width: React.PropTypes.number
    },
    render: function () {
        const { desktopSrc, mobileSrc, ...props } = this.props;
        const src = (window.devicePixelRatio || 1) >= 1.5 ? mobileSrc : desktopSrc;

        return <img {...props} src={src} />;
    }
});

module.exports = Image;



// WEBPACK FOOTER //
// ./app/components/Image.js